"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ase = require("./../utils/ase");
var _util = require("./../utils/util");
var _systemConfig = require("@/api/systemConfig");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * VerifySlide
 * @description 滑块
 * */
//  "captchaType":"blockPuzzle",
var _default2 = exports.default = {
  name: 'VerifySlide',
  props: {
    captchaType: {
      type: String
    },
    type: {
      type: String,
      default: '1'
    },
    phone: {
      type: String,
      default: ''
    },
    // 弹出式pop，固定fixed
    mode: {
      type: String,
      default: 'fixed'
    },
    vSpace: {
      type: Number,
      default: 5
    },
    explain: {
      type: String,
      default: '向右滑动完成验证'
    },
    imgSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '155px'
        };
      }
    },
    blockSize: {
      type: Object,
      default: function _default() {
        return {
          width: '50px',
          height: '50px'
        };
      }
    },
    barSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '40px'
        };
      }
    },
    defaultImg: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      secretKey: '',
      // 后端返回的加密秘钥 字段
      passFlag: '',
      // 是否通过的标识
      backImgBase: '',
      // 验证码背景图片
      blockBackImgBase: '',
      // 验证滑块的背景图片
      backToken: '',
      // 后端返回的唯一token值
      startMoveTime: '',
      // 移动开始的时间
      endMovetime: '',
      // 移动结束的时间
      tipsBackColor: '',
      // 提示词的背景颜色
      tipWords: '',
      text: '',
      finishText: '',
      setSize: {
        imgHeight: 0,
        imgWidth: 0,
        barHeight: 0,
        barWidth: 0
      },
      top: 0,
      left: 0,
      moveBlockLeft: undefined,
      leftBarWidth: undefined,
      // 移动中样式
      moveBlockBackgroundColor: undefined,
      leftBarBorderColor: '#ddd',
      iconColor: undefined,
      iconClass: 'icon-right',
      status: false,
      // 鼠标状态
      isEnd: false,
      // 是够验证完成
      showRefresh: true,
      transitionLeft: '',
      transitionWidth: '',
      loading: false //加载效果
    };
  },
  computed: {
    barArea: function barArea() {
      return this.$el.querySelector('.verify-bar-area');
    },
    resetSize: function resetSize() {
      return _util.resetSize;
    }
  },
  watch: {
    // type变化则全面刷新
    type: {
      immediate: true,
      handler: function handler() {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // 禁止拖拽
    this.$el.onselectstart = function () {
      return false;
    };
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.text = this.explain;
      this.getPictrue();
      this.$nextTick(function () {
        var setSize = _this2.resetSize(_this2); // 重新设置宽度高度
        _this2.setSize.imgWidth = setSize.imgWidth;
        _this2.setSize.imgHeight = setSize.imgHeight;
        _this2.setSize.barHeight = setSize.barHeight;
        _this2.setSize.barWidth = setSize.barWidth;
        _this2.$parent.$emit('ready', _this2);
      });
      var _this = this;
      window.removeEventListener('touchmove', function (e) {
        _this.move(e);
      });
      window.removeEventListener('mousemove', function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.removeEventListener('touchend', function () {
        _this.end();
      });
      window.removeEventListener('mouseup', function () {
        _this.end();
      });
      window.addEventListener('touchmove', function (e) {
        _this.move(e);
      });
      window.addEventListener('mousemove', function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.addEventListener('touchend', function () {
        _this.end();
      });
      window.addEventListener('mouseup', function () {
        _this.end();
      });
    },
    // 鼠标按下
    start: function start(e) {
      e = e || window.event;
      if (!e.touches) {
        // 兼容PC端
        var x = e.clientX;
      } else {
        // 兼容移动端
        var x = e.touches[0].pageX;
      }
      this.startLeft = Math.floor(x - this.barArea.getBoundingClientRect().left);
      this.startMoveTime = +new Date(); // 开始滑动的时间
      if (this.isEnd == false) {
        this.text = '';
        this.moveBlockBackgroundColor = '#337ab7';
        this.leftBarBorderColor = '#337AB7';
        this.iconColor = '#fff';
        e.stopPropagation();
        this.status = true;
      }
    },
    // 鼠标移动
    move: function move(e) {
      e = e || window.event;
      if (this.status && this.isEnd == false) {
        if (!e.touches) {
          // 兼容PC端
          var x = e.clientX;
        } else {
          // 兼容移动端
          var x = e.touches[0].pageX;
        }
        var bar_area_left = this.barArea.getBoundingClientRect().left;
        var move_block_left = x - bar_area_left; // 小方块相对于父元素的left值
        if (move_block_left >= this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2) {
          move_block_left = this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2;
        }
        if (move_block_left <= 0) {
          move_block_left = parseInt(parseInt(this.blockSize.width) / 2);
        }
        // 拖动后小方块的left值
        this.moveBlockLeft = move_block_left - this.startLeft + 'px';
        this.leftBarWidth = move_block_left - this.startLeft + 'px';
      }
    },
    // 鼠标松开
    end: function end() {
      var _this3 = this;
      this.endMovetime = +new Date();
      var _this = this;
      // 判断是否重合
      if (this.status && this.isEnd == false) {
        var moveLeftDistance = parseInt((this.moveBlockLeft || '').replace('px', ''));
        moveLeftDistance = moveLeftDistance * 310 / parseInt(this.setSize.imgWidth);
        var params = {
          captchaType: this.captchaType,
          pointJson: this.secretKey ? (0, _ase.aesEncrypt)(JSON.stringify({
            x: moveLeftDistance,
            y: 5.0
          }), this.secretKey) : JSON.stringify({
            x: moveLeftDistance,
            y: 5.0
          }),
          token: this.backToken
        };
        (0, _systemConfig.knowUserSmsCaptchaApi)(params).then(function (res) {
          if (res.repCode == '0000') {
            _this3.moveBlockBackgroundColor = '#5cb85c';
            _this3.leftBarBorderColor = '#5cb85c';
            _this3.iconColor = '#fff';
            _this3.iconClass = 'icon-check';
            _this3.showRefresh = false;
            _this3.isEnd = true;
            if (_this3.mode == 'pop') {
              setTimeout(function () {
                _this3.$parent.clickShow = false;
                _this3.refresh();
              }, 1500);
            }
            _this3.passFlag = true;
            _this3.tipWords = "".concat(((_this3.endMovetime - _this3.startMoveTime) / 1000).toFixed(2), "s\u9A8C\u8BC1\u6210\u529F");
            var captchaVerification = _this3.secretKey ? (0, _ase.aesEncrypt)(_this3.backToken + '---' + JSON.stringify({
              x: moveLeftDistance,
              y: 5.0
            }), _this3.secretKey) : _this3.backToken + '---' + JSON.stringify({
              x: moveLeftDistance,
              y: 5.0
            });
            setTimeout(function () {
              _this3.tipWords = '';
              _this3.$emit('success', {
                captchaVerification: captchaVerification
              });
            }, 1000);
          } else {
            _this3.moveBlockBackgroundColor = '#d9534f';
            _this3.leftBarBorderColor = '#d9534f';
            _this3.iconColor = '#fff';
            _this3.iconClass = 'icon-close';
            _this3.passFlag = false;
            setTimeout(function () {
              _this.refresh();
            }, 1000);
            _this3.$emit('error', _this3);
            _this3.tipWords = '验证失败';
            setTimeout(function () {
              _this3.tipWords = '';
            }, 1000);
          }
        });
      }
    },
    refresh: function refresh() {
      var _this4 = this;
      this.showRefresh = true;
      this.finishText = '';
      this.transitionLeft = 'left .3s';
      this.moveBlockLeft = undefined;
      this.leftBarWidth = undefined;
      this.transitionWidth = 'width .3s';
      this.leftBarBorderColor = '#ddd';
      this.moveBlockBackgroundColor = '#fff';
      this.iconColor = '#000';
      this.iconClass = 'icon-right';
      this.isEnd = false;
      this.getPictrue();
      setTimeout(function () {
        _this4.status = false;
        _this4.transitionWidth = '';
        _this4.transitionLeft = '';
        _this4.text = _this4.explain;
      }, 300);
    },
    // 请求背景图片和验证图片
    getPictrue: function () {
      var _getPictrue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                captchaType: this.captchaType,
                clientUid: localStorage.getItem('slider'),
                ts: Date.now() // 现在的时间戳
              };
              this.loading = true;
              _context.n = 1;
              return (0, _systemConfig.knowUserCaptchaApi)(params);
            case 1:
              res = _context.v;
              if (res.repCode == '0000') {
                this.backImgBase = res.repData.originalImageBase64;
                this.blockBackImgBase = res.repData.jigsawImageBase64;
                this.backToken = res.repData.token;
                this.secretKey = res.repData.secretKey;
              } else {
                this.text = res.repMsg;
              }
              this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getPictrue() {
        return _getPictrue.apply(this, arguments);
      }
      return getPictrue;
    }()
  }
};